import React from 'react'
import DashhwmSpecial from './dashhwmSpecial';

const WMDemoDashboard = () => {
 
    
  return (
    <div>
        <DashhwmSpecial/>
    </div>
  )
}

export default WMDemoDashboard